/* istanbul ignore file */
//@ts-ignore
import('./bootstrap');
